import { render, staticRenderFns } from "./Candidatos.vue?vue&type=template&id=56b447a6&scoped=true"
import script from "./Candidatos.vue?vue&type=script&lang=js"
export * from "./Candidatos.vue?vue&type=script&lang=js"
import style0 from "./Candidatos.vue?vue&type=style&index=0&id=56b447a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b447a6",
  null
  
)

export default component.exports